import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-card-wrapper',
  template: `
    <div class="card">
      <ng-container #fieldComponent />
    </div>
  `,
  styles: [
    `
      .card {
        border: 1px solid var(--p-greyscale-100);
        border-radius: 16px;
        padding: 24px;
        margin-bottom: 24px;
        display: flex;
      }
    `,
  ],
  standalone: true,
})
export class CardFormlyWrapperComponent extends FieldWrapper {}
